import { Inject, Injectable, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private loaded = false;
  constructor(@Inject(DOCUMENT) private document: Document) {}

  loadTheme(root: ViewContainerRef, themeId: string) {
    const shadowRoot = root.element.nativeElement.getRootNode();
    const headElement = this.document.getElementsByTagName('head')[0];

    const fontElement = this.document.getElementById('font') as HTMLLinkElement;

    const themeHref = `https://embed-staging.insurepay.com/assets/${themeId.replace(
      /[^a-zA-Z0-9-_]/g,
      '',
    )}.css`;

    if (!this.loaded) {
      const style = this.document.createElement('link');
      style.id = 'theme';
      style.rel = 'stylesheet';
      style.type = 'text/css';
      style.href = themeHref;

      shadowRoot.appendChild(style);

      this.loaded = true;
    }

    if (!fontElement) {
      const style = this.document.createElement('link');
      style.rel = 'stylesheet';
      style.href = 'https://embed.insurepay.com/inter.css';

      headElement.appendChild(style);
    }
  }
}
